import 'assets/styles/app.scss';

const loadedComponents = [];

/**
 * Delay scrolling to the hash target until the page is fully loaded
 */
const initialHash = window.location.hash;

if ( initialHash ) {
	const urlWithoutHash = window.location.pathname + window.location.search;

	history.replaceState( null, '', urlWithoutHash );
	window.scrollTo( { top: 0, behavior: 'instant' } );

	window.addEventListener( 'load', () => {
		history.replaceState( null, '', urlWithoutHash + initialHash );

		const target = document.getElementById( decodeURIComponent( initialHash.slice( 1 ) ) );

		if ( target ) {
			target.scrollIntoView( { behavior: 'smooth' } );
		}
	} );
}

document.addEventListener( 'DOMContentLoaded', async () => {
	/**
	 * Bootstrap the components
	 */
	for ( const dataComponent of document.querySelectorAll( '[data-component]' ) ) {
		let componentName = dataComponent.dataset.component;

		if ( loadedComponents.indexOf( componentName ) === - 1 ) {
			loadedComponents.push( componentName );

			try {
				let component = await import(
					/* WebpackMode: "lazy" */
					/* webpackPrefetch: true */
					/* webpackPreload: true */
					`components/${componentName}/${componentName}.js`
					);

				component.default();

			} catch ( error ) {
				console.error( 'Loading error: ', error );
			}
		}
	}
} );
